import * as React from 'react';
import TextField from '@mui/material/TextField';
import ListSelection from "./ListSelection";
import { CSVString2Array } from '../../Utilities/Utilities';
import Autocomplete from '@mui/material/Autocomplete';

 const  LicenceUpdateModFeaturesInformation = ({
    data, 
    onFieldChange, 
    baseModules, 
    baseFeatures, 
    flexLicenceTemplates, 
    licenceTypes, 
    mainFeatures = [],
    CFFeatures = [],
    branding = [],
    presetWorkflows = [],
    correctivesFeatures = [],
    selectedMainFeatures = [],
    selectedCFFeatures = [],
    selectedBranding = [],
    selectedPresetWorkflows = [],
    selectedCorrectivesFeatures = []
        }) => {    

    if (data !== undefined) {
    console.log("data: ", data);
    // console.log("modules: ", baseModules);
    // console.log("features: ", baseFeatures);
    // console.log("flexTemplates: ", flexLicenceTemplates);
    }
    const templates = flexLicenceTemplates.map((el) => {
        return el.name;
    });

    return (
        <div >
            <h2 style={{marginTop: "20px"}}>Update Modules and Features on existing licences</h2>
            <div style={{marginTop: "20px"}}>This option allows you to add modules and/or features on existing licences based on the licence's flex licence type.</div>
            <div style={{color: "red"}}>Warning: there is no UNDO to this features</div>
            { flexLicenceTemplates !== undefined &&
                 <div style={{marginTop: "20px"}}>
                    <Autocomplete
                        id="type"
                        className="combobox"
                        autoHighlight={true}
                        disablePortal
                        noOptionsText="Licence Type"
                        value={data.type}
                        options={licenceTypes.sort((a,b) => a > b ? 1 : -1)}
                        onChange={(event, value) => onFieldChange(event, value, "type")}
                        renderInput={(params) => <TextField {...params} label="Licence Type" />}
                    />
                </div>
            }
            { flexLicenceTemplates !== undefined && data.type === "kinetisense-flex" &&
                 <div style={{marginTop: "20px"}}>
                    <Autocomplete
                        id="name"
                        className="combobox"
                        autoHighlight={true}
                        disablePortal
                        noOptionsText="Licence Template"
                        value={data.name}
                        options={templates.sort((a,b) => a > b ? 1 : -1)}
                        onChange={(event, value) => onFieldChange(event, value, "name")}
                        renderInput={(params) => <TextField {...params} label="Licence Template" />}
                    />
                </div>
            }
            {baseModules !== undefined &&    
                <div style={{marginTop: "20px"}}>
                    <ListSelection 
                    baseList={baseModules} 
                    selectedList={CSVString2Array(data.modules).sort((a,b) => a > b ? 1 : -1)} 
                    title={"Modules"} 
                    id = "modules" 
                    onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                    />
                </div>
            }
            {/* {baseFeatures !== undefined &&
                <div style={{marginTop: "20px"}}>
                    <ListSelection 
                    baseList={baseFeatures} 
                    selectedList={CSVString2Array(data.features).sort((a,b) => a > b ? 1 : -1)} 
                    title={"Features"} 
                    id="features" 
                    onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                    />
                </div>
                
            } */}
            <div style={{marginTop: "20px"}}>
                <ListSelection 
                baseList={mainFeatures.sort((a, b) => (a > b ? 1 : -1))} 
                selectedList={selectedMainFeatures} 
                title={"App Features"} 
                id="features" 
                onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                />
            </div>
            <div style={{marginTop: "20px"}}>
                <ListSelection 
                baseList={CFFeatures.sort((a, b) => (a > b ? 1 : -1))} 
                selectedList={selectedCFFeatures} 
                title={"Custom Field Templates"} 
                id="cfTemplates" 
                onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                />
            </div>
            <div style={{marginTop: "20px"}}>
                <ListSelection 
                baseList={branding.sort((a, b) => (a > b ? 1 : -1))} 
                selectedList={selectedBranding}
                title={"Soft Branding"} 
                id="branding" 
                onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                />
            </div>
            <div style={{marginTop: "20px"}}>
                <ListSelection 
                baseList={presetWorkflows.map((a) => a.name).sort((a, b) => (a > b ? 1 : -1))} 
                selectedList={selectedPresetWorkflows} 
                title={"Preset Workflows"} 
                id="presetWorkflows" 
                onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                />
            </div>
            <div style={{marginTop: "20px"}}>
                <ListSelection 
                baseList={correctivesFeatures.sort((a, b) => (a > b ? 1 : -1))} 
                selectedList={selectedCorrectivesFeatures} 
                title={"Correctives"} 
                id="correctives" 
                onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                />
            </div>
        </div>
    );
   
}

export default LicenceUpdateModFeaturesInformation;